var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 29,
    viewBox: "0 0 42 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 28,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7502 19.6454H10.2058L8.29785 12.3158C8.20729 11.9787 8.015 11.6806 7.73215 11.5401C7.02627 11.1871 6.24844 10.9061 5.3999 10.7644V10.4822H9.49871C10.0644 10.4822 10.4887 10.9061 10.5594 11.3984L11.5494 16.6855L14.0925 10.4822H16.5662L12.7502 19.6454ZM17.9804 19.6454H15.5775L17.5561 10.4822H19.9591L17.9804 19.6454ZM23.0679 13.0207C23.1387 12.5272 23.5629 12.245 24.0579 12.245C24.8357 12.1741 25.683 12.3158 26.3902 12.6677L26.8144 10.6948C26.1073 10.4126 25.3295 10.2709 24.6236 10.2709C22.2914 10.2709 20.5943 11.5401 20.5943 13.3017C20.5943 14.6418 21.7964 15.3454 22.6449 15.7693C23.5629 16.192 23.9165 16.4742 23.8458 16.8968C23.8458 17.5308 23.1387 17.813 22.4328 17.813C21.5842 17.813 20.7357 17.6017 19.9591 17.2487L19.5348 19.2228C20.3834 19.5746 21.3014 19.7163 22.1499 19.7163C24.765 19.7859 26.3902 18.5179 26.3902 16.6146C26.3902 14.2179 23.0679 14.0774 23.0679 13.0207ZM34.7999 19.6454L32.8919 10.4822H30.8425C30.4182 10.4822 29.994 10.7644 29.8526 11.1871L26.3194 19.6454H28.7931L29.2869 18.3066H32.3262L32.6091 19.6454H34.7999ZM31.1961 12.9498L31.902 16.4033H29.9233L31.1961 12.9498Z",
    fill: "#172B85"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentVisa);
export default __webpack_public_path__ + "static/media/PaymentVisa.d01c1acfe69d44b226252469407e979b.svg";
export { ForwardRef as ReactComponent };